// Shared left/right column width persistence for the dashboard.
// Keys are namespaced by feature so counsel and conversation-list stay independent.
// Width is per agent (localStorage), not per conversation.

export const createColumnWidthStore = ({
  storagePrefix,
  defaultWidth,
  minWidth,
  maxWidth,
  minSiblingWidth,
}) => {
  const keyFor = userId => `${storagePrefix}:${userId || 'anonymous'}`;

  const clamp = (value, windowWidth = 0) => {
    let max = maxWidth;
    if (windowWidth > 0) {
      max = Math.min(
        maxWidth,
        Math.max(minWidth, windowWidth - minSiblingWidth)
      );
    }
    const n = Number(value);
    if (!Number.isFinite(n)) return defaultWidth;
    return Math.min(max, Math.max(minWidth, Math.round(n)));
  };

  const load = (userId, windowWidth = 0) => {
    try {
      const raw = window.localStorage.getItem(keyFor(userId));
      return clamp(raw, windowWidth);
    } catch (err) {
      return clamp(defaultWidth, windowWidth);
    }
  };

  const save = (userId, width, windowWidth = 0) => {
    try {
      window.localStorage.setItem(
        keyFor(userId),
        String(clamp(width, windowWidth))
      );
    } catch (err) {
      // localStorage may be disabled or quota exceeded; fail silently.
    }
  };

  return { clamp, load, save, defaultWidth, minWidth, maxWidth };
};

// Conversation list (left of the main chat). Defaults mirror the previous
// fixed Tailwind widths (~340 / ~412) while allowing agents to drag wider.
export const conversationListWidth = createColumnWidthStore({
  storagePrefix: 'conversation_list_width',
  defaultWidth: 360,
  minWidth: 280,
  maxWidth: 640,
  // Leave room for the message pane (+ optional counsel / contact panels).
  minSiblingWidth: 480,
});
